<template>
  <b-dropdown variant="link" no-caret>
    <span slot="button-content">Menu</span>
    <b-dropdown-item v-for = "item in menus"
                     :to="{name: 'geo-'+item.name}"
                     :key="item.name">
      {{item.desc}}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    components: {
    },
    props: {
    },
    data () {
      return {
        menus: [
          {
            name: 'zip',
            desc: 'Enter Zip Codes'
          },
          {
            name: 'zipRange',
            desc: 'Zip Code Range'
          },
          {
            name: 'zipPaste',
            desc: '2000 ZIP/Carrier Routes/ZIP+4'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoZipMenu.vue